import { Navigate, Route, Routes } from "react-router";

import { useApi } from "./context/context";
import {
  Account,
  Projects,
  Invoices,
  Login,
  NoAccess,
  NotFound,
  Order,
  ProjectPage,
  SetPassword,
  UnderMaintenance,
  ArtWarehouse,
  ArtObject
} from "./pages";

const LandingRoute = ({
  canAccessProjects,
  canAccessArtWarehouse,
  hasInvoiceAccess
}) => {
  if (canAccessProjects) {
    return <Navigate to="/projects" replace />;
  }

  if (canAccessArtWarehouse) {
    return <Navigate to="/art-warehouse" replace />;
  }

  if (hasInvoiceAccess) {
    return <Navigate to="/invoices" replace />;
  }

  return <Navigate to="/no-access" replace />;
};

const AppRoutes = () => {
  const {
    companyId,
    isVerified,
    canAccessProjects,
    canAccessArtWarehouse,
    hasInvoiceAccess
  } = useApi();

  const isMaintenance = process.env.REACT_APP_MAINTENANCE === "true";

  if (companyId && isVerified) {
    return (
      <Routes>
        <Route
          path="/"
          element={
            <LandingRoute
              canAccessProjects={canAccessProjects}
              canAccessArtWarehouse={canAccessArtWarehouse}
              hasInvoiceAccess={hasInvoiceAccess}
            />
          }
        />
        {canAccessProjects && <Route path="/projects" element={<Projects />} />}
        <Route path="/no-access" element={<NoAccess />} />
        <Route path="/profile" element={<Account />} />
        <Route path="/account/set-password" element={<SetPassword />} />
        <Route path="/account/set-password/:userId" element={<SetPassword />} />
        {hasInvoiceAccess && <Route path="/invoices" element={<Invoices />} />}
        {canAccessProjects && (
          <>
            <Route path="/project/:projectId" element={<ProjectPage />} />
            <Route path="/order/:orderId" element={<Order />} />
          </>
        )}
        {canAccessArtWarehouse && (
          <>
            <Route path="/art-warehouse" element={<ArtWarehouse />} />
            <Route path="/art-warehouse/:objectId" element={<ArtObject />} />
          </>
        )}

        <Route
          path="/login"
          element={isMaintenance ? <UnderMaintenance /> : <Login />}
        />
        <Route path="/login-test" element={<Login />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/profile" element={<Account />} />
      <Route path="/account/set-password" element={<SetPassword />} />
      <Route path="/account/set-password/:userId" element={<SetPassword />} />
      <Route
        path="/login"
        element={isMaintenance ? <UnderMaintenance /> : <Login />}
      />
      <Route path="/login-test" element={<Login />} />
      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
};

export default AppRoutes;
